import { StandardTemplate } from "@biz/definitions/StandardTemplate";
import { SunSailType } from "@biz/definitions/SunSailDefinitions";
import { CalcProductLogic } from "@biz/items/CalcProductLogic";
import { CalcSailLogic } from "@biz/items/sunSail/CalcSailLogic";
import { FieldErrorMap } from "@biz/models/FieldErrorMap";
import { IStandardCollection2dForm } from "@biz/models/Sail2dDefinitions";
import { PD } from "@biz/PD";
import { ICalcContext, ICalculatedProductResult, ProjectCheckErrorType } from "@biz/projectCalculation/ProjectDefinitions";

export class CalcStandardCollection2d {
  static calc2d(product: IStandardCollection2dForm, slc: ICalcContext): ICalculatedProductResult {

    const keys = Object.keys(product.sails);
    for (const key of keys) {
      const sail = product.sails[key];

      if (sail.cloth && sail.colorId) {
        const sunSailArea = StandardTemplate.getArea(sail.sizeId);
        const cloth = sail.cloth;
        CalcSailLogic.addClothArticle(slc, {
          count: sail.count,
          cloth,
          colorId: sail.colorId,
          sunSailArea,
          features: { colorId: sail.colorId, standardSize: sail.sizeId, waterDirection: sail.waterDirection }
        })
      }
    }

    if (keys.length === 0) {
      CalcProductLogic.addError(slc.errors, ProjectCheckErrorType.Error, "net", slc.lc.t("Rule_EmptyStandardCollection"))
    }

    CalcSailLogic.calcCSFArticles(slc, SunSailType.Standard, "S");
    CalcProductLogic.finalizeCalcContext(slc, { incomplete: !product, defaultOfferList: "S", count: 1 });

    return {
      id: product.id,
      pd: PD.productToPD(product),
      infos: slc.infos,
      errors: slc.errors,
      errorMap: FieldErrorMap.errorMapFromErrors(slc.errors || []),
      articles: slc.ruleArticles,
      product,
    };
  }
}